import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
    standalone: true,
    selector: 'sirius-play-button',
    templateUrl: './play-button.component.html',
    styleUrls: ['./play-button.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PlayButtonComponent {
    readonly disabled = input(false);
    readonly hovered = input(false);
    readonly focusable = input(true);
    readonly ariaLabel = input('Play');
}
